import type { JSX } from "react";
import { Container } from "../HtmlTags/Container/Container";
import { Paragraph } from "../HtmlTags/Paragraph/Paragraph";
import "./PageLoader.css";
import { SHARE_LABELS } from "../../../utils/constants";

export interface PageLoaderProps {
  message?: string;
}

export function PageLoader({ message }: PageLoaderProps): JSX.Element {
  return (
    <Container className="page-loader-wrap" data-testid="page-loader">
      <Container className="page-loader">{SHARE_LABELS.PAGE_LOADER}</Container>
      {message ? (
        <Paragraph className="page-loader-message" data-testid="page-loader-message">
          {message}
        </Paragraph>
      ) : null}
    </Container>
  );
}
